export const aboutFallback = {
  "_id": {
    "$oid": "6927f2d1937bb8e9c88b1cdc"
  },
  "poster": "/uploads/1764622279107.png",
  "description": "Genvision - the signature annual event of Symbiotek Council, is aimed at providing a platform for exploring innovative and creative ideas to guide you towards a great career in Biosciences & Bioengineering. Keeping up with the tradition of 28 successful years, we present to you GenVision 2026.\r\nBringing together high-quality researchers with cutting-edge expertise in basic and applied bio-related area, the event provides a platform for upcoming talents and empowers students with a scientific and technical temperament which provides them leadership for emerging needs of the society.",
  "gallery": [
    "/uploads/about/1764230266367-620494123.JPG",
    "/uploads/about/1764230266701-62627373.JPG",
    "/uploads/about/1764230266956-13641900.JPG"
  ],
  "schedule": [
    {
      "date": "",
      "event": "",
      "time": "",
      "_id": {
        "$oid": "6928047b853cafbbbc9d4674"
      }
    }
  ],
  "sponsors": [
    {
      "name": "Genetix",
      "logo": "/uploads/1764622279190.gif",
      "_id": {
        "$oid": "692dffc7a964c0059f50cf65"
      }
    },
    {
      "name": "Ostic Pharma",
      "logo": "/uploads/1764622279191.png",
      "_id": {
        "$oid": "692dffc7a964c0059f50cf66"
      }
    },
    {
      "name": "SRL",
      "logo": "/uploads/1764622279192.jpg",
      "_id": {
        "$oid": "692dffc7a964c0059f50cf67"
      }
    },
    {
      "name": "BioLinx",
      "logo": "/uploads/1764622279192.png",
      "_id": {
        "$oid": "692dffc7a964c0059f50cf68"
      }
    },
    {
      "name": "IIC",
      "logo": "/uploads/1764622279194.jpg",
      "_id": {
        "$oid": "692dffc7a964c0059f50cf69"
      }
    },
    {
      "name": "Virion",
      "logo": "/uploads/1764622279202.jpg",
      "_id": {
        "$oid": "692dffc7a964c0059f50cf6a"
      }
    },
    {
      "name": "Allianz Bio",
      "logo": "/uploads/1764622279202.jpg",
      "_id": {
        "$oid": "692dffc7a964c0059f50cf6b"
      }
    },
    {
      "name": "Infrared Optics",
      "logo": "/uploads/1764622279251.png",
      "_id": {
        "$oid": "692dffc7a964c0059f50cf6c"
      }
    }
  ],
  "__v": 21
}